import {Card, CardContent} from '@/components/ui/card'
import {useCalculator, KPI_NASTUPY} from '@/contexts/CalculatorContext';
import {BanknoteIcon} from "lucide-react";

export function TotalPeriodCard() {
    const {
        margin,
        nastupy,
        currentPeriod,
        getAllPeriods,
        getNastupyPercentage,
        calculate1MarginProfit,
        calculate3ContractProfit,
    } = useCalculator()

    const periodData = getAllPeriods()
    const previousPeriod = currentPeriod > 0 ? periodData[currentPeriod - 1] : null
    const previousIsKpiMet = previousPeriod ? previousPeriod.isKpiMet : false
    const previousBonus = previousPeriod ? previousIsKpiMet ? getNastupyPercentage(previousPeriod.nastupy) : 0 : 0

    return (
        <Card className={`transition-all duration-300 border-2 ${nastupy > 0 ? 'border-green-500 bg-green-50' : 'border-red-500 bg-red-50'} relative`}>
            <CardContent className="pt-6">
                <div className="space-y-3">
                    <div className="flex items-center gap-2">
                        <BanknoteIcon className={`w-4 h-4 ${nastupy >= 1 ? 'text-green-500' : 'text-orange-500'}`}/>
                        <span className="font-medium">Souhrn za aktuální období</span>
                    </div>
                    <div className="space-y-2">
                        <div className="flex justify-between items-center w-full">
                            <span className="text-xs text-muted-foreground">Celkem</span>
                            <span className="text-2xl font-bold">
                                {((calculate1MarginProfit(margin, previousBonus, nastupy) /2) + calculate3ContractProfit() ).toLocaleString()} Kč
                            </span>
                        </div>
                    </div>
                    <div className="space-y-2">
                        {[
                            {title: '1. složka (aktuální)', value: Math.round(calculate1MarginProfit(margin, previousBonus, nastupy) /2).toLocaleString() + ' Kč'},
                            // {title: '2. složka (pro další období)', value: isKpiMet ? getNastupyPercentage(nastupy) + ' %' : '0%'},
                            {title: '3. složka (aktuální)', value: nastupy < KPI_NASTUPY ? "0 Kč" : calculate3ContractProfit().toLocaleString() + " Kč"},
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="flex justify-between py-2 border-b last:border-0 text-xs"
                            >
                                <span className="text-muted-foreground">{item.title}</span>
                                <span className="font-medium">{item.value}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}